var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from '../fetch/fetch';
import { METHOD } from '../fetch/types';
const getFileArray = (files) => {
    if (!files)
        return null;
    if (Array.isArray(files) && files.length > 0)
        return files;
    if (!Array.isArray(files))
        return [files];
    return null;
};
const call = (token, route, body = {}, files, progressCallback, fileDownloadMimeType) => __awaiter(void 0, void 0, void 0, function* () {
    const backendRoute = `/functional-interface/${route}`;
    const fileArray = getFileArray(files);
    const result = yield fetch(METHOD.POST, backendRoute, Object.assign(Object.assign({}, body), { token }), fileArray, progressCallback, fileDownloadMimeType);
    if (result instanceof Blob) {
        return result;
    }
    else if (result.status && result.response) {
        return result;
    }
    return false;
});
export default call;
